import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { subscriptionTransactionsDispatchers as dispatchSelector } from 'reduxModules/subscriptions/dispatchers'
import CollapsibleOrder from '../CollapsibleOrder'
import './styles.css'

export class SubscriptionTransactions extends Component {
  componentDidMount() {
    const { isLoaded, subscription, loadSubscriptionTransactions } = this.props
    const { id } = subscription

    if (!isLoaded) loadSubscriptionTransactions(id)
  }

  render() {
    const { subscription } = this.props

    if (!_.has(subscription, 'transactions')) return null
    return (
      <div id="subscriptionTransactions">
        {_.size(subscription.transactions) > 0 && (
          <>
            <div className="table-header">
              <div className="date">order date</div>
              <div className="order-id">order id</div>
              <div className="status">status</div>
              <div className="total">total</div>
            </div>
            {subscription.transactions.map((transaction, transactionIndex) => (
              <CollapsibleOrder
                key={transactionIndex}
                {...transaction}
                isMobile={this.props.isMobile}
                subscription={subscription}
                isTransaction
              />
            ))}
          </>
        )}
        {_.size(subscription.transactions) === 0 && (
          <span>There is no more information available.</span>
        )}
      </div>
    )
  }
}

SubscriptionTransactions.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  loadSubscriptionTransactions: PropTypes.func.isRequired,
  subscription: PropTypes.shape({
    active: PropTypes.bool,
    braintreeId: PropTypes.string,
    free: PropTypes.bool,
    id: PropTypes.number,
    plan: PropTypes.string,
    transactions: PropTypes.arrayOf(PropTypes.object)
  }),
  subscriptionTransaction: PropTypes.bool,
  isTransaction: PropTypes.bool
}

SubscriptionTransactions.defaultProps = {
  orders: [],
  subscription: null,
  subscriptionTransaction: false,
  isTransaction: false
}

export default connect(null, dispatchSelector)(SubscriptionTransactions)
